module.exports = __webpack_public_path__ + "static/media/ax.88fcc7ec.svg";